/**
 * UpgradeTypes can be used to group multiplicative bonuses together
 */
export enum UpgradeType {
    None,
    VoidBatteries,
    Nanobots
}